module.exports = __webpack_public_path__ + "static/img/yangzheng.148a7ba2.jpg";